import { useRouter } from 'next/router';
import { TabsContent } from '@radix-ui/react-tabs';
import Router from 'next/router';
import Link from 'next/link';
import Layout, { TightLayout } from '@/components/layout/Layout';
import { sanitizeRegion } from '@/utils/explorer';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb';
import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/tabs';
import Regions from '@/components/ui/regions/Regions';
import useExplorerData from '@/hooks/useExplorerData';
import RegionDetails from '@/components/ui/regions/RegionDetails';
import { RegionMapWrapper } from '@/components/ui/regions/RegionMapWrapper';
import RegionMetrics from '@/components/ui/regions/RegionMetrics';

const VALID_SECTIONS = ['metrics', 'map'];

export default function Index() {
  const router = useRouter();
  const { sections = [] } = router.query;
  const [regionName = '', section = ''] = sections;

  const { data } = useExplorerData();
  const regions = data?.regions || [];
  const stats = data?.stats;
  const region = data?.regions?.find(
    region => sanitizeRegion(region.name) === sanitizeRegion(regionName),
  );

  const defaultSection = VALID_SECTIONS.includes(section) ? section : 'metrics';

  const handleTabChange = (value: string) => {
    Router.push(`/network/regions/${regionName}/${value}`, undefined, {
      shallow: true,
    });
  };

  const { description, roadLengthByTypeKm, airportData, bridgeData } =
    region?.metadata ?? {};
  const shouldRenderNewRegionPage =
    description != null &&
    roadLengthByTypeKm != null &&
    (airportData != null || bridgeData != null);

  return region?.name ? (
    <Layout>
      <div className="flex size-full flex-col">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link href="/network/regions">Regions</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{region.name}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <Tabs value={defaultSection} className="flex size-full flex-col">
          <TabsList className="my-4 md:my-6">
            <TabsTrigger
              value="metrics"
              onClick={() => handleTabChange('metrics')}>
              Metrics
            </TabsTrigger>
            <TabsTrigger value="map" onClick={() => handleTabChange('map')}>
              Map
            </TabsTrigger>
          </TabsList>
          <TabsContent value="metrics">
            {shouldRenderNewRegionPage ? (
              <RegionDetails region={region} regions={regions} />
            ) : (
              <RegionMetrics region={region} />
            )}
          </TabsContent>
          <TabsContent value="map" className="size-full">
            <RegionMapWrapper region={region} regions={regions} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  ) : (
    <TightLayout>
      <Regions regions={regions} stats={stats} />
    </TightLayout>
  );
}
